// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>18</span>&nbsp;&nbsp;Let your hand be upon the man at your right hand,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the son of man you made so strong for yourself.<br> </p> </div></div>";
// Exports
module.exports = code;